module.exports = __webpack_public_path__ + "img/attendance_3.1b323669.png";